import * as React from 'react'
import { Provider } from 'react-redux'
import store from '../../store'
import TwoFactorSetup from './setup'

export default function TwoFactoSetupApp(props) {
  return (
    <Provider store={store}>
      <TwoFactorSetup {...props} />
    </Provider>
  )
}
